
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./mobxreact.cjs.production.min.js')
} else {
  module.exports = require('./mobxreact.cjs.development.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/mobx-react/dist/index.js
// module id = 44
// module chunks = 0